import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { StudentNoteService } from "@/services/api/student-note";
import { useQuery } from "@tanstack/react-query";
import { Loader2Icon, PlusIcon } from "lucide-react";
import { useState } from "react";
import ModalAddStudentNote from "./modal-add-student-note";
import StudentNotesList from "./student-notes-list";

type Props = {
  studentId: string;
  isOpen: boolean;
  onClose: () => void;
};

export default function ModalStudentNotes({
  studentId,
  isOpen,
  onClose,
}: Props) {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["student_notes", studentId],
    enabled: Boolean(studentId) && isOpen,
    refetchOnWindowFocus: false,
    queryFn: () => StudentNoteService.getAll(studentId),
  });

  return (
    <>
      <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
        <SheetContent className="bg-white overflow-scroll max-h-screen min-w-[40vw]">
          <SheetHeader className="flex flex-row items-center justify-between pr-10">
            <SheetTitle>Anotações</SheetTitle>
            {isLoading ? (
              <Loader2Icon className="h-4 w-4 animate-spin" />
            ) : (
              <Button size="sm" onClick={() => setIsAddModalOpen(true)}>
                <PlusIcon size={16} className="mr-2" />
                Nova anotação
              </Button>
            )}
          </SheetHeader>

          <div className="mt-6">
            <StudentNotesList
              studentId={studentId}
              notes={data}
              isLoading={isLoading}
              variant="light"
              onDeleted={() => refetch()}
            />
          </div>
        </SheetContent>
      </Sheet>

      <ModalAddStudentNote
        studentId={studentId}
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={() => refetch()}
      />
    </>
  );
}
